import React from "react";
import { useTable } from "../../Components/useTable";

const RIDList = () => {
  const type = "Special RID";
  const limitPerpage = 100;
  const pageRowslinit = [20,50,100];
  const headCells = [
    { id: "specialId", numeric: false, label: "RID" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "price", numeric: false, label: "Price" },
    { id: "ridStatus", numeric: false, label: "Status" },
   
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default RIDList;
